import { CreateButton } from 'components/button/CreateButton';
import { DocumentTitle } from 'components/DocumentTitle';
import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { TablePageLayout } from 'components/page/styled';
import { usePermissions } from 'contexts/PermissionsContext';
import { usePagedCorporationsDataSource } from 'custom_hooks/data_hooks/data_source/corporationDataSource';
import { CorporationsTable } from 'pages/Settings/Corporations/CorporationsTable';
import { CreateCorporationModal } from 'pages/Settings/Corporations/CreateCorporationModal';
import { SearchCreateButtonContainer } from 'pages/Settings/shared/styled';
import { useEffect, useState } from 'react';
import { ContextualPageProps } from 'utils/types';

export function CorporationsPage({ corporation }: ContextualPageProps) {
    const { canCreateCorporation } = usePermissions();
    const dataSource = usePagedCorporationsDataSource({
        name: 'corporations-table',
        defaultFilter: {
            nameSearch: '',
            corporationId: corporation?.Id,
        },
    });

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [nameSearch, setNameSearch] = useState('');
    const { setFilter, reloadPage } = dataSource;

    const onCorporationsCreate = () => {
        setCreateModalOpen(false);
        reloadPage();
    };

    useEffect(() => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            nameSearch,
        }));
    }, [nameSearch, setFilter]);

    return (
        <TablePageLayout>
            <DocumentTitle title="Corporations Settings" />
            <SearchCreateButtonContainer>
                <DebouncedSearchInput
                    placeholder="Search"
                    value={nameSearch}
                    onChange={setNameSearch}
                />
                {canCreateCorporation && (
                    <CreateButton onClick={() => setCreateModalOpen(true)} />
                )}
                {createModalOpen && (
                    <CreateCorporationModal
                        onCreate={onCorporationsCreate}
                        onClose={() => setCreateModalOpen(false)}
                    />
                )}
            </SearchCreateButtonContainer>
            <CorporationsTable dataSource={dataSource} />
        </TablePageLayout>
    );
}
